import { styled } from "styled-components";

export const VideoSectionWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 96px 24px;
  background-color: ${({ theme }) => theme.colors.default[50]};
`;

export const VideoSectionContainer = styled.div`
  max-width: 1024px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 48px;
  width: 100%;
`;

export const VideoSectionTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  text-align: center;

  & > p {
    color: ${({ theme }) => theme.colors.default[600]};
  }
`;

export const VideoFrameInnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 12px;
  overflow: hidden;
`;
